
import { defineComponent, ref, onMounted } from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Dropzone } from "dropzone";
import { read, readFile, utils } from "xlsx";

export default defineComponent({
  name: "merchant-excel-modal",
  components: {},
  data: () => ({}),
  methods: {
    submit() {
      this.submitValid();
    },
  },
  setup(props, context) {
    const formRef = ref<null | HTMLFormElement>(null);
    const excelModalRef = ref<null | HTMLElement>(null);

    const loading = ref(false);
    const formData = ref({
      apiKey: "13IjnqZ60hKIwlxaPDlgmkjhIuiM2RfMOK2wphfslMhQ",
    });

    const rules = ref({
      apiKey: [
        {
          required: true,
          message: "Id is required",
          trigger: "change",
        },
      ],
    });

    const submitValid = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate(async (valid) => {
        if (valid) {
          loading.value = true;
          try {
            let res = await parseFile(addedFile);
            context.emit("on-handle-completed", res);
            hideModal(excelModalRef.value);
          } catch (error) {
            console.log(error);
            addedFile = ref(null);
          }

          loading.value = false;
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      });
    };

    const handleCompleted = (data) => {
      context.emit("on-handle-completed", data);
      loading.value = false;
      hideModal(excelModalRef.value);
    };

    const dropRef = ref(null);
    let addedFile = ref(null);

    onMounted(() => {
      if (dropRef.value !== null) {
        var dropzone = new Dropzone(dropRef.value, {
          url: "https://httpbin.org/post",
          paramName: "file", // The name that will be used to transfer the file
          maxFiles: 1,
          maxFilesize: 10, // MB
          addRemoveLinks: true,
          acceptedFiles: ".csv,.txt,.xlsx,.xls",
        });

        dropzone.on("addedfile", function (file) {
          addedFile = file;
        });
      }
    });

    const parseFile = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          if (event) {
            parseXlsx(event.target?.result)
              .then((result) => {
                return resolve(result.worksheet);
              })
              .catch((error) => {
                return reject(error);
              });
          }
        };

        if (file.type === "text/csv") {
          reader.readAsText(file);
        } else {
          reader.readAsBinaryString(file);
        }
      });
    };

    const parseXlsx = (data) => {
      const workbook =
        typeof window === "undefined"
          ? readFile(data)
          : read(data, { type: "binary" });
      const sheetNames = workbook.SheetNames;
      if (sheetNames.length === 0) {
        return Promise.reject(new Error("Error in sheet"));
      }
      const sheets = workbook.Sheets;
      const json = utils.sheet_to_json(sheets[sheetNames[0]], {
        header: 1,
        // defVal: '',
        blankrows: false,
      });

      if (json.length === 0) {
        return Promise.reject(new Error("Empty sheet"));
      }

      return Promise.resolve({ worksheet: json });
    };

    return {
      formData,
      rules,
      submitValid,
      handleCompleted,
      formRef,
      dropRef,
      loading,
      excelModalRef,
      addedFile,
    };
  },
});
